/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { FeeExclusionItemDto } from '@gh/builder-shared-data';
import { ID } from '@gh/common-shared-data';

export type FeeExclusionsListItem = FeeExclusionItemDto;
export type FeeExclusionsListPutItemDto = { itemId: ID; itemCode: string };

export const DEFAULT_FEE_EXCLUSIONS_FILTER = { searchString: '' };
